import { BlogShared } from './../../general/shared/blog-shared';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-simple-popup',
  templateUrl: './simple-popup.component.html',
  styleUrls: ['./simple-popup.component.scss'],
})
export class SimplePopupComponent implements OnInit {
  constructor(
    private dialogref: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private blogShared: BlogShared
  ) {}

  ngOnInit() {}

  action(title: string) {
    if (title === 'اشتراک گذاری') {
      this.blogShared.simplePopupShareAction();
    } else {
      this.blogShared.simplePopupAction();
    }
    this.dialogref.close();
  }
}
